var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5 16.5L12.9584 12.9521M14.9211 8.21053C14.9211 9.99027 14.2141 11.6971 12.9556 12.9556C11.6971 14.2141 9.99027 14.9211 8.21053 14.9211C6.43078 14.9211 4.72394 14.2141 3.46547 12.9556C2.207 11.6971 1.5 9.99027 1.5 8.21053C1.5 6.43078 2.207 4.72394 3.46547 3.46547C4.72394 2.207 6.43078 1.5 8.21053 1.5C9.99027 1.5 11.6971 2.207 12.9556 3.46547C14.2141 4.72394 14.9211 6.43078 14.9211 8.21053Z","stroke":"white","strokeWidth":"2","strokeLinecap":"round"}));
}

SearchInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
